var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EngineService } from './engine.service';
import { TimerangeModel } from './models/animation/timerange.model';
import { plainToClass } from 'class-transformer';
import { get } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "./engine.service";
var AnimationService = /** @class */ (function () {
    function AnimationService(engineService) {
        this.engineService = engineService;
    }
    AnimationService.prototype.getChapterLocalTimerange = function (chapterId) {
        var chapter = Human.timeline.activeRoot._chapters.find(function (_chapter) { return _chapter.id === chapterId; });
        return plainToClass(TimerangeModel, chapter.timeRange);
        // Human.timeline.activeRoot._nowBranch;
        // get branch timeline:               <branch>.getTimeframe()
        // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
        // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  
    };
    AnimationService.prototype.mapGlobalTimeToLocal = function (time, params) {
        if (params === void 0) { params = {}; }
        return Human.timeline.activeRoot.mapGlobalTime(time, params);
    };
    AnimationService.prototype.mapLocalTimeToGlobal = function (chapterId, time) {
        var branch = Human.timeline.activeRoot._chapters.find(function (chapter) { return chapter.id === chapterId; });
        return Human.timeline.activeRoot.mapBranchTime(branch, time);
    };
    AnimationService.prototype.isChapterAnimated = function (chapter) {
        var isAnimated = chapter.timelineMap
            .filter(function (timeline) {
            return get(timeline, 'data.timeline') !== 'dummy' &&
                get(timeline, 'data.timeline.id') !== 'dummy' &&
                get(timeline, 'data.timeline.id.id') !== 'dummy';
        }).length > 0;
        return isAnimated;
    };
    AnimationService.prototype.scrub = function (options) {
        var which = options.which ? options.which : 'first';
        Human.timeline.scrub({
            time: options.time,
            borderCondition: {
                which: which,
                direction: 'forward'
            }
        });
    };
    AnimationService.prototype.getTimeFrame = function () {
        return Human.timeline.getTimeFrame();
    };
    AnimationService.prototype.getTime = function () {
        return Human.timeline.time;
    };
    AnimationService.prototype.isPlaying = function () {
        return Human.timeline.playing;
    };
    AnimationService.prototype.play = function (options) {
        // spread props, but filter any that are undefined.
        // The engine does `hasOwnProperty` checks, so `undefined` params can slip through the cracks if not careful
        var playParams = Object.keys(options).reduce(function (acc, option) {
            if (acc[option] === undefined) {
                delete acc[option];
            }
            return acc;
        }, __assign({}, options));
        Human.timeline.play(playParams);
    };
    AnimationService.prototype.unpause = function () {
        Human.timeline.unpause();
    };
    AnimationService.prototype.pause = function () {
        Human.timeline.pause();
    };
    AnimationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnimationService_Factory() { return new AnimationService(i0.ɵɵinject(i1.EngineService)); }, token: AnimationService, providedIn: "root" });
    return AnimationService;
}());
export { AnimationService };
